<span
    data-testid="display-value"
    class="ap-amount-display"
    [ngClass]="{
        'ap-amount-display--extra-padding': hasExtraPadding(),
        'ap-amount-display--positive-accent': hasPositiveAccent(),
        'ap-amount-display--negative-accent': hasNegativeAccent(),
        'ap-amount-display--negative-contrast': hasNegativeContrast(),
        'ap-amount-display--positive-contrast': hasPositiveContrast(),
        'ap-amount-display--cancelled': cancelled(),
        'ap-amount-display--large': size() === 'large',
        'ap-amount-display--medium': size() === 'medium',
        'ap-amount-display--emphasis': emphasize()
    }"
>
    @if (estimate()) {
        ≈
    }
    {{ displayValue() }}
</span>
